import { CellValueChangedArgs } from 'src/app/layout/cell-value-changed-args';
import { FilterFieldValue } from 'src/app/apps/subscription/classes';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';
import {
  SectionTableFilter,
  SectionTableFilterTypes,
} from './../../../models/section-table-filter';
import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  AfterViewInit,
} from '@angular/core';
import { CellSetting } from '../../cell-setting';
import { LayoutService } from '../../layout.service';
import { EventType, RecordModel } from '../../record-model';
import {
  ModuleStructure,
  Section,
  SectionAdditionalInformation,
} from 'src/app/models/module-structure';
import * as moment from 'moment';
import * as g from 'src/app/globals';
import { TableSectionAction } from 'src/app/models/table-section-action';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-table-section',
  templateUrl: './table-section.component.html',
  styleUrls: ['./table-section.component.less'],
})
export class TableSectionComponent implements OnInit, AfterViewInit {
  @Input() cellSettings: CellSetting[];
  @Input() moduleStructure: ModuleStructure;
  @Input() section: Section;
  @Input() recordModel: RecordModel;
  @Input() recordId: string;
  @Input() tableName = '';
  @Input() displayFooter = false;
  @Input() displayFilter = true;
  @Input() actions: TableSectionAction[] = [];
  @Input() actionType = '';

  @Input() serverSide = false;
  @Input() totalRecords = 0;

  @Input() pageSize = 30;
  @Output() pageSizeChanged = new EventEmitter<number>();

  @Input() pageIndex = 1;
  @Output() pageIndexChanged = new EventEmitter<number>();

  @Input() sortedByDir: string;
  @Input() sortedByField: number;

  sortDirection: string;
  sortField: number;

  filters: { [key: string]: SectionTableFilter };
  @Output() filtersChanged = new EventEmitter<{
    [key: string]: SectionTableFilter;
  }>();

  isTableLoadingVal: boolean = true;
  filterData: FilterFieldValue[];
  global = g;

  @Input() set isTableLoading(value: boolean) {
    this.isTableLoadingVal = value;
  }

  get isTableLoading(): boolean {
    return this.isTableLoadingVal;
  }

  get additionalInformation(): SectionAdditionalInformation {
    if (this.section !== undefined) {
      return this.section.AdditionalInformationParsed;
    }
  }

  screenSize = '';

  tableWidth = 0;
  datasetValue: any[] = [];
  @Input() set dataset(value: any[]) {
    this.isTableLoadingVal = false;

    this.datasetValue = [...[], ...value];
    this.calculateTotals();
    if (!this.serverSide) {
      this.updateFilter();
    } else {
      let index = 0;
      this.visibleRows = [];
      this.dataset.forEach((row) => {
        this.visibleRows.push({ index: index++, data: row });
      });
    }
  }

  get dataset(): any[] {
    return this.datasetValue;
  }

  tableColsValue: any[] = [];
  @Input() set tableCols(value: any[]) {
    this.tableColsValue = value;
    this.visibleColumn = this.getVisibleColumn();
  }
  get tableCols(): any[] {
    return this.tableColsValue;
  }

  visibleRows: { index: number; data: any[] }[] = [];
  visibleColumn: any[] = [];

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    this.screenSize = this.layoutService.screenSize;
    this.layoutService.screenSizeEmitter.subscribe((d) => {
      this.screenSize = d;
    });

    if (this.cellSettings === undefined) {
      this.cellSettings = this.section.ColumnSettingsParsed;
    }

    this.pageSize = this.section?.AdditionalInformationParsed?.DefaultPageSize;
    if (this.pageSize == null || this.pageSize === 0) {
      this.pageSize = 30;
    }
    if (this.recordModel !== undefined) {
      this.dataset = [];
      if (
        this.section?.ParentFields == null ||
        this.section?.ParentFields === undefined ||
        this.section?.ParentFields === ''
      ) {
        this.layoutService
          .getSectionTableColumns(this.section.Id)
          .subscribe((d: any) => {
            this.tableCols = JSON.parse(d.cols);
            this.visibleColumn = this.getVisibleColumn();

            if (this.recordId !== undefined && this.recordId !== '') {
              this.getSectionTableData();
            }
          });

        if (this.recordId !== undefined && this.recordId !== '') {
          this.getSectionTableData();
        }
      }
    } else {
      this.visibleColumn = this.getVisibleColumn();
      this.calculateTotals();
    }

    this.layoutService.fieldValueChanged.subscribe(
      (d: FieldValueChangedArgs) => {
        if (this.section == null || this.section.ParentFields == null) {
          return;
        }
        const parentFields = this.section.ParentFields.split(';');
        if (
          parentFields.indexOf(
            `${d.sectionTagName}.${d.recordProperty.Name}`,
          ) === -1
        ) {
          return;
        }
        const filterData: FilterFieldValue[] = [];
        if (parentFields != null && parentFields !== undefined) {
          for (const filterField of parentFields) {
            const data = filterField.split('.');
            const category = this.recordModel.Categories.find(
              (x) => x.Id === data[0],
            );
            const property = category.Lines[0].Properties.find(
              (p) => p.Name === data[1],
            );

            if (
              property.ValueAsObject !== undefined &&
              property.ValueAsObject !== ''
            ) {
              filterData.push({
                FieldName: category.Id + '.' + property.Name,
                Value: [property.ValueAsObject],
              });
            } else {
              filterData.push({
                FieldName: category.Id + '.' + property.Name,
                Value: [''],
              });
            }
          }
        }

        this.filterData = filterData;
        this.loadTableData();
      },
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.recordModel !== undefined && this.section.ParentFields != null) {
        const parentFields = this.section.ParentFields.split(';');
        const filterData: FilterFieldValue[] = [];

        if (parentFields != null && parentFields !== undefined) {
          for (const filterField of parentFields) {
            const data = filterField.split('.');
            const cat = this.recordModel.Categories.find(
              (x) => x.Id === data[0],
            );

            const parentProp = cat.Lines[0].Properties.find(
              (p) => p.Name === data[1],
            );

            const val =
              parentProp !== undefined
                ? cat.Lines[0].Properties.find((p) => p.Name === data[1])
                    .ValueAsObject
                : '';

            if (val !== undefined && val !== '') {
              filterData.push({
                FieldName: cat.Id + '.' + data[1],
                Value: [val],
              });
            } else {
              filterData.push({
                FieldName: cat.Id + '.' + data[1],
                Value: [''],
              });
            }
          }
        }

        this.filterData = filterData;
        this.loadTableData();
      } else if (
        this.section?.AdditionalInformationParsed.ExecuteQueryEvenWhenAdd &&
        this.recordModel.EventType === EventType.Create
      ) {
        this.loadTableData();
      }
    }, 1);
  }

  public loadTableData() {
    this.layoutService
      .getSectionTableData(
        this.section,
        this.section.SQLStatementId,
        this.recordId,
        this.moduleStructure.module.Id,
        this.section.Id,
        this.filterData,
      )
      .subscribe((d: any) => {
        const currentCat = this.recordModel.Categories.find(
          (c) => c.Id === this.section.XmlTagName,
        );
        setTimeout(() => {
          this.dataset = d.table.rowsArray;
          currentCat.Dataset = this.dataset;

          if (this.recordModel.TableSections === undefined) {
            this.recordModel.TableSections = {};
          }

          this.recordModel.TableSections[this.section.XmlTagName] =
            d.table.rowsArray;
        }, 100);
        // this.dataset = d.table.rowsArray;
        if (
          this.tableCols == null ||
          this.tableCols === undefined ||
          this.tableCols.length === 0
        ) {
          this.tableCols = d.columns;
        }
      });
  }

  colHeaderCheckChanged(col, event) {
    let i = 0;
    for (const row of this.visibleRows) {
      const cellToChange = this.cellSettings[i];
      if (
        col.Name === 'CHECKED' ||
        col.Name === 'SELECTED' ||
        col.Name === 'Selected' ||
        col.Name === 'X'
      ) {
        row.data[col.Name] = event;
        this.layoutService.triggerCellValueChanged({
          column: col,
          dataset: this.dataset,
          name: this.tableName,
          row: i,
          moduleStructure: this.moduleStructure,
          recordModel: this.recordModel,
          massChange: true,
        });
      } else if (
        (col.Name === cellToChange.column && cellToChange === undefined) ||
        (cellToChange != null && !cellToChange.settings.readonly)
      ) {
        row.data[col.Name] = event;
        this.layoutService.triggerCellValueChanged({
          column: col,
          dataset: this.dataset,
          name: this.tableName,
          row: i,
          moduleStructure: this.moduleStructure,
          recordModel: this.recordModel,
          massChange: true,
        });
      }

      i++;
    }
  }

  calculateTotals() {
    this.displayFooter = false;
    for (const col of this.visibleColumn) {
      if (col.FooterType === 0) {
        continue;
      } else if (col.FooterType === 1) {
        this.displayFooter = true;
        col.FooterResult = 0;
        for (const row of this.visibleRows) {
          col.FooterResult += row.data[col.Name];
        }
      } else if (col.FooterType === 2) {
        this.displayFooter = true;
        col.FooterResult = 0;
        for (const row of this.visibleRows) {
          col.FooterResult += row.data[col.Name];
        }

        if (this.visibleRows.length === 0) {
          col.FooterResult = 0;
        } else {
          col.FooterResult = col.FooterResult / this.visibleRows.length;
        }
      }
    }
  }

  changeSorting(i: number, direction: string) {
    if (direction === null) {
      return;
    }

    if (direction === 'ascend') {
      this.sortDirection = 'ASC';
    } else {
      this.sortDirection = 'DESC';
    }
    this.sortField = i;

    this.updateFilter();
  }

  updateFilter() {
    if (this.filters === undefined) {
      return;
    }
    const keys = Object.keys(this.filters);
    for (const key of keys) {
      const filter = this.filters[key];
      if (this.visibleColumn.find((c) => c.Name === key) !== undefined) {
        filter.filterType = SectionTableFilter.getFilterType(
          this.visibleColumn.find((c) => c.Name === key).Type,
        );
      }
    }

    this.pageIndex = 1;
    this.filtersChanged.emit(this.filters);
    if (this.serverSide) {
      return;
    }

    if (this.filters === null || this.filters === undefined) {
      this.visibleRows = this.dataset;
      return;
    }

    const visibleRows: { index: number; data: any[] }[] = [];

    let i = 0;
    for (const row of this.dataset) {
      let isRowVisible = true;
      for (const key of keys) {
        let isRowVisibleBasedOnFilter = true;
        const filter = this.filters[key];

        if (filter.filterType === SectionTableFilterTypes.string) {
          if (
            filter.singleValue !== undefined &&
            filter.singleValue !== null &&
            filter.singleValue.toString() !== ''
          ) {
            isRowVisibleBasedOnFilter =
              row[key] !== undefined &&
              row[key] != null &&
              row[key]
                .toString()
                .toLowerCase()
                .indexOf(filter.singleValue.toString().toLowerCase()) !== -1;
          } else if (filter.singleValue === '') {
            isRowVisibleBasedOnFilter = true;
          }
        } else if (filter.filterType === SectionTableFilterTypes.select) {
          if (
            filter.singleValue !== undefined &&
            filter.singleValue !== null &&
            filter.singleValue.toString() !== ''
          ) {
            isRowVisibleBasedOnFilter =
              row[key] !== undefined &&
              row[key] != null &&
              row[key].toString().toLowerCase() ===
                filter.singleValue.toString().toLowerCase();
          } else {
            isRowVisibleBasedOnFilter = true;
          }
        } else if (filter.filterType === SectionTableFilterTypes.date) {
          if (filter.valueFrom !== null || filter.valueTo !== null) {
            if (row[key] === null || row[key] === '') {
              isRowVisibleBasedOnFilter = false;
            } else {
              const dateValue = moment(
                row[key],
                g.companyConfiguration.MomentDateFormat,
              );

              if (
                /*(filter.valueTo === null || dateValue <= filter.valueTo) &&
                (filter.valueFrom === null || dateValue >= filter.valueFrom)*/
                (filter.valueTo === null ||
                  dateValue.isSameOrBefore(filter.valueTo, 'day')) &&
                (filter.valueFrom === null ||
                  dateValue.isSameOrAfter(filter.valueFrom, 'day'))
              ) {
                isRowVisibleBasedOnFilter = true;
              } else {
                isRowVisibleBasedOnFilter = false;
              }
            }
          } else {
            isRowVisibleBasedOnFilter = true;
          }
        } else if (filter.filterType === SectionTableFilterTypes.number) {
          if (filter.valueFrom === '') {
            filter.valueFrom = null;
          }

          if (filter.valueTo === '') {
            filter.valueTo = null;
          }

          if (filter.valueFrom !== null || filter.valueTo !== null) {
            if (row[key] === null || row[key] === '') {
              isRowVisibleBasedOnFilter = false;
            } else {
              const numberValue = Number(row[key]);

              if (
                (filter.valueTo === null || numberValue <= +filter.valueTo) &&
                (filter.valueFrom === null || numberValue >= +filter.valueFrom)
              ) {
                isRowVisibleBasedOnFilter = true;
              } else {
                isRowVisibleBasedOnFilter = false;
              }
            }
          } else {
            isRowVisibleBasedOnFilter = true;
          }
        }

        isRowVisible = isRowVisible && isRowVisibleBasedOnFilter;
        if (!isRowVisible) {
          break;
        }
      }

      if (isRowVisible) {
        visibleRows.push({ index: i, data: row });
      }

      i = i + 1;
    }

    this.visibleRows = visibleRows;
    this.calculateTotals();
  }

  getVisibleColumn(): any[] {
    const result: any[] = [];
    if (this.filters == null || this.filters === undefined) {
      this.filters = {};
    }
    if (this.tableCols === undefined) {
      /*for (const col of this.tableCols) {
        if (col.Width === 0 || col.Width === undefined || col.Width == null) {
          this.tableWidth += 200;
        } else {
          this.tableWidth += col.Width;
        }
      }*/

      return result;
    }

    for (const col of this.tableCols) {
      if (col.Visible) {
        if (
          col.FilterSQLStatementId != null &&
          col.FilterSQLStatementId !== undefined
        ) {
          this.getOptions(col);
        }
        result.push(col);

        if (
          this.filters[col.Name] == null ||
          this.filters[col.Name] === undefined
        ) {
          this.filters[col.Name] = {
            valueFrom: null,
            valueTo: null,
            singleValue: null,
            filterType: SectionTableFilter.getFilterType(col.Type),
          };
        }

        if (col.Width === 0 || col.Width === undefined || col.Width == null) {
          this.tableWidth += 200;
        } else {
          this.tableWidth += col.Width;
        }
      }
    }

    return result;
  }

  getOptions(column: any) {
    if (column.Options != null && column.Options.length !== 0) {
      return;
    }

    const paramsNames: string[] = [];
    const vals: string[] = [];

    this.layoutService
      .getSelectOptions(0, column.FilterSQLStatementId, paramsNames, vals)
      .subscribe((d: any) => {
        if (d === null || d === undefined) {
          return;
        }
        column.Options = d.Values.rowsArray;
      });
  }

  getCardTitle(row: { data: any }): string {
    // use the first visible column as the card title
    const first = this.visibleColumn[0];
    return first ? row.data[first.Name] : '';
  }

  getSectionTableData(): void {
    this.layoutService
      .getSectionTableData(
        this.section,
        this.section.SQLStatementId,
        this.recordId,
        this.moduleStructure.module.Id,
        this.section.Id,
      )
      .subscribe((d: any) => {
        /*if (
          this.tableCols == null ||
          this.tableCols === undefined ||
          this.tableCols.length === 0
        )*/ {
          this.tableCols = d.columns;
        }
        if (this.recordId !== undefined && this.recordId !== '') {
          setTimeout(() => {
            this.dataset = d.table.rowsArray;
            if (this.recordModel.TableSections === undefined) {
              this.recordModel.TableSections = {};
            }

            this.recordModel.TableSections[this.section.XmlTagName] =
              d.table.rowsArray;
          }, 100);
        }
      });
  }
}
